import React, { useState } from "react";
import axios from "axios";
import { Button } from "shards-react";

const FileUploader = ({
  label = "Upload File",
  maxSizeMB = 5,
  onUploadSuccess,
  onError,
}) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState("");

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file && file.size > maxSizeMB * 1024 * 1024) {
      setError(`File size should not exceed ${maxSizeMB} MB`);
      return;
    }
    setError("");
    setSelectedFile(file);
  };

  const uploadFile = () => {
    if (!selectedFile) {
      setError("Please select a file first.");
      return;
    }

    const formData = new FormData();
    formData.append("file", selectedFile, selectedFile.name);

    setUploading(true);
    axios
      .post(`${process.env.REACT_APP_API_URL}/admin/upload`, formData, {
        headers: {
          "x-access-token": localStorage.getItem("jwtToken"),
        },
      })
      .then((res) => {
        setUploading(false);
        if (res.status === 200) {
          onUploadSuccess(res.data.path);
        } else {
          const message = "Upload failed. Please try again.";
          onError(message);
          setError(message);
        }
      })
      .catch(() => {
        const message = "Upload error. Check your connection.";
        onError(message);
        setUploading(false);
        setError(message);
      });
  };

  return (
    <div>
      <div className="input-group input-group-merge mb-3">
        <input
          type="file"
          onChange={handleFileChange}
          className="form-control"
        />
        <Button onClick={uploadFile} disabled={uploading}>
          {uploading ? "Uploading..." : label}
        </Button>
      </div>
      {error && <p className="text-danger mt-1 d-block">{error}</p>}
    </div>
  );
};

export default FileUploader;
